export default __webpack_public_path__ + "static/media/split-bill-step-1@3x.cd962167.png";